import { render, staticRenderFns } from "./UserAgreementKYY.vue?vue&type=template&id=68e4f12c&scoped=true"
import script from "./UserAgreementKYY.vue?vue&type=script&lang=js"
export * from "./UserAgreementKYY.vue?vue&type=script&lang=js"
import style0 from "./UserAgreementKYY.vue?vue&type=style&index=0&id=68e4f12c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e4f12c",
  null
  
)

export default component.exports